import { StyledWikiArticle } from '@/components/styles'
import addSoftHyphenation from '@/lib/addSoftHyphenation'
import genLinkParams from '@/lib/generateLinkParams'
import { ArrowButton } from '@/components'
import Link from 'next/link'

export default function WikiArticle(props) {
  const { id, title, short_content: desc, slug, ...otherProps } = props

  const [href, as] = genLinkParams({ type: 'wiki-article', slug })

  return (
    <StyledWikiArticle {...otherProps}>
      <Link href={href} as={as} passHref>
        <StyledWikiArticle.Link />
      </Link>

      <StyledWikiArticle.Bg />

      <StyledWikiArticle.Arrow>
        <ArrowButton />
      </StyledWikiArticle.Arrow>

      <StyledWikiArticle.Content>
        {title && (
          <StyledWikiArticle.Title>{addSoftHyphenation(title, 17)}</StyledWikiArticle.Title>
        )}

        {desc && <StyledWikiArticle.Description>{desc}</StyledWikiArticle.Description>}
      </StyledWikiArticle.Content>
    </StyledWikiArticle>
  )
}
